// import { MDBEcommerceGallery } from 'mdb-react-ecommerce-gallery';
// import React from 'react';

// const basicPhotos = [
//   {
//     thumbnail: 'https://mdbcdn.b-cdn.net/img/Photos/Thumbnails/Slides/1.webp',
//     src: 'https://mdbcdn.b-cdn.net/img/Photos/Slides/1.webp',
//     alt: 'Test alt 1',
//   },
//   {
//     thumbnail: 'https://mdbcdn.b-cdn.net/img/Photos/Thumbnails/Slides/2.webp',
//     src: 'https://mdbcdn.b-cdn.net/img/Photos/Slides/2.webp',
//     alt: 'Test alt 2',
//   },
//   {
//     thumbnail: 'https://mdbcdn.b-cdn.net/img/Photos/Thumbnails/Slides/3.webp',
//     src: 'https://mdbcdn.b-cdn.net/img/Photos/Slides/3.webp',
//     alt: 'Test alt 3',
//   },
// ];

// export default function CrateYourCompany() {
//   return (
//     <MDBEcommerceGallery imagesSrc={basicPhotos} />
//   )
// }
import {
  MDBContainer
} from 'mdb-react-ui-kit';
import React from 'react';
import './../../App.css';
export default function CrateYourCompany() {
  return (
    <MDBContainer className="d-flex align-items-center justify-content-center mt-5">
    {/* <MDBLightbox>
      <MDBRow>
        <MDBCol lg='3'>
          <MDBLightboxItem
            src='https://mdbootstrap.com/img/Photos/Thumbnails/Slides/1.webp'
            fullscreenSrc='https://opengrit.com/images/registration.mp4'
            className='w-100'
          /> 
        </MDBCol>
        <MDBCol lg='3'>
          <MDBLightboxItem
            src='https://mdbootstrap.com/img/Photos/Thumbnails/Slides/2.webp'
            fullscreenSrc='https://mdbootstrap.com/img/Photos/Slides/2.webp'
            className='w-100'
          />
        </MDBCol>
        <MDBCol lg='3'>
          <MDBLightboxItem            
            src='https://mdbootstrap.com/img/Photos/Thumbnails/Slides/3.webp'
            fullscreenSrc='https://mdbootstrap.com/img/Photos/Slides/3.webp'
            className='w-100'
          />
        </MDBCol>
        <MDBCol lg='3'>
          <MDBLightboxItem
            src='https://mdbootstrap.com/img/Photos/Thumbnails/Slides/4.webp'
            fullscreenSrc='https://mdbootstrap.com/img/Photos/Slides/4.webp'
            className='w-100'
          />
        </MDBCol>
      </MDBRow>
    </MDBLightbox>
  */}
  {/* <div className="ratio ratio-16x9">
          <iframe
            src="https://opengrit.com/images/registration"
            title="YouTube video"
            allowfullscreen
          ></iframe>
        </div> */}
    
    {/* <div className="ratio ratio-16x9">
      <iframe
        src="https://opengrit.com/images/registration"
        title="YouTube video"
        allowfullscreen
      ></iframe>
    </div>
    */}
      <div className="ratio ratio-16x9 me-2">
        <video controls>
          <source src="https://opengrit.com/images/registration" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="ratio ratio-16x9">
        <video controls>
          <source src="https://opengrit.com/images/propertyPresent" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </MDBContainer>




  );
}